<div class="w-100">
  Lengte berekenen
</div>
<mat-progress-bar mode="indeterminate"></mat-progress-bar>